import { jsx } from "panel";
import { ItemsMenuEl } from "common/components/items-menu";
import { DropMenuPaneEl } from "common/components/drop-menu-pane";
import { ButtonBarEl } from "common/components/button-bar";
import { ButtonEl } from "common/components/button";
import { SvgIconEl } from "common/components/svg-icon";
import { ButtonTheme } from "common/components/button/constants";
import { DropMenuEl } from "common/components/drop-menu";
import { TooltipEl } from "common/components/tooltip";
import { DateRangePickerEl } from "common/widgets/date-range-picker";
import { LiftType } from "common/report/util/lift/types";
import { MenuDropdownState } from "common/widgets/lift-comparison-menu/types";
import { Visibility } from "common/components/base/stackable";
import { LiftBaselineMenuEl } from "common/widgets/lift-comparison-menu/lift-baseline-menu";
import { SpinnerEl } from "common/components/spinner";
import { SpinnerSize } from "common/components/spinner/types";
import { ToggleEl } from "common/components/toggle";
import { ToggleTheme } from "common/components/toggle/types";
import { DisplaySize, Placement } from "common/components/tooltip/types";
import compareSvg from "common/assets/images/charts/compare.svg";
import { formatText } from "common/util/format-text";
function MenuOptions(_ref) {
  let {
    sections,
    onClick
  } = _ref;
  return /* @__PURE__ */ jsx("div", { sel: ".time-comparison-options", "data-sentry-component": "MenuOptions", "data-sentry-source-file": "template.tsx" }, /* @__PURE__ */ jsx(ItemsMenuEl, { props: {
    sections
  }, on: {
    clickItem: onClick
  }, "data-sentry-element": "ItemsMenuEl", "data-sentry-source-file": "template.tsx" }));
}
function CustomDateComparisonMenu(_ref2) {
  let {
    title,
    buttonText,
    pickerOptions,
    onChangeDate,
    onApply,
    onBack
  } = _ref2;
  return /* @__PURE__ */ jsx("div", { "data-sentry-component": "CustomDateComparisonMenu", "data-sentry-source-file": "template.tsx" }, /* @__PURE__ */ jsx(DropMenuPaneEl, { sel: ".mp-time-comparison-selector-menu", attrs: {
    header: title,
    "show-back-button": true
  }, style: {
    overflow: "visible"
  }, on: {
    "back-click": onBack
  }, "data-sentry-element": "DropMenuPaneEl", "data-sentry-source-file": "template.tsx" }, /* @__PURE__ */ jsx("div", { sel: ".mp-query-datepicker-container" }, /* @__PURE__ */ jsx(DateRangePickerEl, { attrs: pickerOptions, on: {
    changeDateRange: onChangeDate
  }, "data-sentry-element": "DateRangePickerEl", "data-sentry-source-file": "template.tsx" }))), /* @__PURE__ */ jsx(ButtonBarEl, { sel: ".mp-button-bar-primary", attrs: {
    tabindex: 0
  }, on: {
    click: onApply
  }, "data-sentry-element": "ButtonBarEl", "data-sentry-source-file": "template.tsx" }, buttonText));
}
function BaselineComparison(_ref3) {
  let {
    segment,
    breakdowns,
    onApply,
    onBack
  } = _ref3;
  if (!breakdowns.length) {
    return /* @__PURE__ */ jsx("div", { sel: ".spinner-container" }, /* @__PURE__ */ jsx(SpinnerEl, { attrs: {
      size: SpinnerSize.Large
    } }));
  }
  return /* @__PURE__ */ jsx("div", { "data-sentry-component": "BaselineComparison", "data-sentry-source-file": "template.tsx" }, /* @__PURE__ */ jsx(DropMenuPaneEl, { sel: ".mp-time-comparison-selector-menu", attrs: {
    header: "Select Baseline",
    "show-back-button": true
  }, style: {
    overflow: "visible"
  }, on: {
    "back-click": onBack
  }, "data-sentry-element": "DropMenuPaneEl", "data-sentry-source-file": "template.tsx" }, /* @__PURE__ */ jsx("div", { sel: ".baseline-container" }, /* @__PURE__ */ jsx(LiftBaselineMenuEl, { attrs: {
    "baseline-options": breakdowns,
    segment
  }, on: {
    select: (ev) => onApply(ev)
  }, "data-sentry-element": "LiftBaselineMenuEl", "data-sentry-source-file": "template.tsx" }))));
}
export function template() {
  var _this$attr;
  let menuBody;
  switch (this.state.dropdownState) {
    case MenuDropdownState.CustomTime:
      menuBody = /* @__PURE__ */ jsx(CustomDateComparisonMenu, { title: this.t("reports.lift-comparison.custom-date.title"), buttonText: this.t("reports.lift-comparison.custom-date.apply"), onBack: () => this.onPaneBackClick(), onApply: () => this.applyDateRange(), pickerOptions: this.getDateRangePickerOptions(), onChangeDate: (ev) => this.changedDateRange(ev) });
      break;
    case MenuDropdownState.Baseline:
      menuBody = /* @__PURE__ */ jsx(BaselineComparison, { segment: this.getSegmentNameAndLabel().segmentLabel, breakdowns: this.attr("selected-breakdown-segments"), onBack: () => this.onPaneBackClick(), onApply: (ev) => this.applyBaseline(ev) });
      break;
    case MenuDropdownState.List:
      menuBody = /* @__PURE__ */ jsx(MenuOptions, { sections: this.getSections(), onClick: (ev) => this.onPresetMenuClick(ev) });
      break;
  }
  let buttonExtra = null;
  if (this.attr("selected-date") || this.attr("selected-lift-comparison")) {
    buttonExtra = /* @__PURE__ */ jsx("div", { sel: ".remove-button", on: {
      click: (ev) => this.handleRemove(ev)
    } }, /* @__PURE__ */ jsx(SvgIconEl, { attrs: {
      icon: "circle-clear"
    } }));
  } else {
    buttonExtra = /* @__PURE__ */ jsx(SvgIconEl, { attrs: {
      icon: "caret-down"
    } });
  }
  return /* @__PURE__ */ jsx(
    "div",
    { sel: ".mp-lift-comparison-menu", "data-sentry-component": "template", "data-sentry-source-file": "template.tsx" },
    /* @__PURE__ */ jsx(ButtonEl, { attrs: {
      theme: ButtonTheme.Secondary,
      pressed: this.state.isMenuOpen,
      elref: "compareButton"
    }, on: {
      click: () => this.update({
        isMenuOpen: !this.state.isMenuOpen
      })
    }, "data-sentry-element": "ButtonEl", "data-sentry-source-file": "template.tsx" }, /* @__PURE__ */ jsx("span", { sel: ".lift-label" }, /* @__PURE__ */ jsx("span", { sel: ".label-prefix" }, this.selectedLabel()), buttonExtra)),
    // dont' show the tooltip when the menu is open as we've already clicked into it and it can look weird
    !this.state.isMenuOpen && /* @__PURE__ */ jsx(TooltipEl, { attrs: {
      placement: Placement.Top,
      "image-src": compareSvg,
      size: DisplaySize.Small
    } }, /* @__PURE__ */ jsx("div", { sel: ".info-tooltip" }, formatText(this.t("reports.lift-comparison.tooltips.compare-info")))),
    /* @__PURE__ */ jsx(DropMenuEl, { attrs: {
      open: this.state.isMenuOpen
    }, on: {
      change: (ev) => this.update({
        isMenuOpen: Visibility.Open === ev.detail.state,
        dropdownState: MenuDropdownState.List
      })
    }, "data-sentry-element": "DropMenuEl", "data-sentry-source-file": "template.tsx" }, this.state.isMenuOpen && menuBody),
    this.isLiftToggleAvailable() && /* @__PURE__ */ jsx(null, null, /* @__PURE__ */ jsx(ToggleEl, { attrs: {
      theme: ToggleTheme.SegmentedController,
      selected: ((_this$attr = this.attr("selected-lift-comparison")) === null || _this$attr === void 0 ? void 0 : _this$attr.type) === LiftType.Time ? "lift" : "absolute",
      options: this.liftToggleOptions()
    }, on: {
      select: (ev) => this.handleLiftToggle(ev)
    } }))
  );
}
